import type { PublicationRu } from '../i18n';

/** Russian overlays for the publications registry, keyed by slug. */
export const publicationsRu: Record<string, PublicationRu> = {
  'anu-runtime': {
    title: 'Agent Native Universe — открытая среда исполнения для самоорганизующихся агентов',
    venue: 'Open-source-релиз (MIT)',
    statusLabel: 'Публичный артефакт',
    summary:
      'Версионированный релиз agent-native-среды исполнения под лицензией MIT: согласование отношений, экономика ресурсов, византийское согласие, рекурсивная организация. Код и есть публикация.',
  },
  'uwt-preprint': {
    title: 'Unified Wholeness Theory — пакет препринта',
    venue: 'arXiv (готовится)',
    statusLabel: 'Препринт готовится',
    summary:
      'Теоретическое направление, подготовленное к открытой публикации: зарегистрированные эксперименты, автоматические тесты для проверки утверждений и воспроизводимый пакет препринта.',
  },
  'balansis-library': {
    title: 'Balansis — открытая библиотека для вычислений, устойчивых к особым точкам',
    venue: 'Open-source-релиз (AGPL-3.0) · PyPI',
    statusLabel: 'Публичный артефакт',
    summary:
      'Численный фундамент лаборатории выпущен библиотекой, а не заметкой: деление на ноль, переполнение и потеря точности обрабатываются явно в самом API, а не откладываются в обработку крайних случаев. Исходный код на GitHub, релизы на PyPI — код и есть публикация.',
  },
};
